import Cimg1 from '../images/causes/1.jpg';
import Cimg2 from '../images/causes/2.jpg';
import Cimg3 from '../images/causes/3.jpg';
import Cimg4 from '../images/causes/4.jpg';
import Cimg5 from '../images/causes/5.jpg';
import Cimg6 from '../images/causes/6.jpg';
import Cimg7 from '../images/causes/7.jpg';
import Cimg8 from '../images/causes/8.jpg';
import Cimg9 from '../images/causes/9.jpg';
import Cimg10 from '../images/causes/10.jpg';

import Csing1 from '../images/cause-single/1.jpg'
import Csing2 from '../images/cause-single/2.jpg'
import Csing3 from '../images/cause-single/3.jpg'
import Csing4 from '../images/cause-single/4.jpg'
import Csing5 from '../images/cause-single/5.jpg'
import Csing6 from '../images/cause-single/6.jpg'
import Csing7 from '../images/cause-single/7.jpg'
import Csing8 from '../images/cause-single/8.jpg'
import Csing9 from '../images/cause-single/9.jpg'
import Csing10 from '../images/cause-single/10.jpg'





const causes = [
    {
        id: '1',
        title: 'Help Us Build Point Cook Islamic Centre',
        subtitle: 'Support Your Local Mosque',
        docomunt: 'Join us in building a place of worship and community for Muslims in Point Cook. Your donation will help establish prayer facilities, educational programs, and community services.',
        slug: 'point-cook-mosque',
        Cimg: Cimg1,
        CSimg: Csing1,
        location: 'Point Cook, Victoria',
        date: 'Ongoing',
        tag: 'Mosque',
        progress: 35,
        goal: 500000,
        raised: 175000,
        targetGoal: 500000,
    },
    {
        id: '2',
        title: 'Gift an Education… Make a Life Better!',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact2',
        Cimg: Cimg2,
        CSimg: Csing2,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 50,
        goal: 25000,
        raised: 24000,
        targetGoal: 29000,
    },
    {
        id: '3',
        title: 'Donity is a nonprofit that supports',
        subtitle: 'Help The Poor Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact3',
        Cimg: Cimg3,
        CSimg: Csing3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 70,
        goal: 21000,
        raised: 10000,
        targetGoal: 22000,
    },
    {
        id: '4',
        title: 'Online Donation In The Modern World',
        subtitle: 'Help The Poor Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact3',
        Cimg: Cimg4,
        CSimg: Csing4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 50,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '5',
        title: 'Little Help Can Make a Big Difference',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact4',
        Cimg: Cimg5,
        CSimg: Csing5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '6',
        title: 'Gift an Education… Make a Life Better!',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact5',
        Cimg: Cimg6,
        CSimg: Csing6,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '7',
        title: 'Let’s Help Children Build a Happy Future.',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact7',
        Cimg: Cimg7,
        CSimg: Csing7,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '8',
        title: 'Online Donation In The Modern World',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact8',
        Cimg: Cimg8,
        CSimg: Csing8,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '9',
        title: 'Gift an Education… Make a Life Better!',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact9',
        Cimg: Cimg9,
        CSimg: Csing9,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },
    {
        id: '10',
        title: 'Donity is a nonprofit that supports',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Business is the activity of making ones buying and selling product',
        slug: 'established-fact10',
        Cimg: Cimg10,
        CSimg: Csing10,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
        tag: 'Health',
        progress: 95,
        goal: 20000,
        raised: 20000,
        targetGoal: 20000,
    },

]
export default causes






